// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"_2Uay4yg","h5Text":"_2exddYC","h4Text":"_32JNulh","h3Text":"_2Ea2b9V","srOnly":"_2QGHDoJ","link":"_3J4mMka _2Uay4yg","minibagFooter":"_3L-aps4"};